"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContentstackImg = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("./hooks");

var _polyfilled = _interopRequireDefault(require("use-resize-observer/polyfilled"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["image", "offsetX", "offsetY", "quality", "crop", "pixelRatio", "debug", "fit", "optimized"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Use styled components to allow for theming.


var Img = _styledComponents.default.img.withConfig({
  displayName: "ContentstackImg__Img",
  componentId: "sc-j8y615-0"
})([""]);

var ContentstackImg = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _image$dimension, _image$dimension2;

  var image = _ref.image,
      offsetX = _ref.offsetX,
      offsetY = _ref.offsetY,
      quality = _ref.quality,
      crop = _ref.crop,
      pixelRatio = _ref.pixelRatio,
      debug = _ref.debug,
      fit = _ref.fit,
      optimized = _ref.optimized,
      imgProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      reference = _useState2[0],
      setReference = _useState2[1];

  var _useResizeObserver = (0, _polyfilled.default)(),
      width = _useResizeObserver.width,
      height = _useResizeObserver.height,
      setResizeRef = _useResizeObserver.ref;

  var setRef = (0, _react.useCallback)(function (ref) {
    setReference(ref);
    setResizeRef(ref);
  }, [setResizeRef]);

  _react.default.useImperativeHandle(ref, function () {
    return reference;
  }, [reference]);

  var dimensions = {
    width: width,
    height: height
  };
  var optimizedSrc = (0, _hooks.useOptimizedSrc)({
    image: image,
    dimensions: dimensions,
    quality: quality,
    crop: crop,
    pixelRatio: pixelRatio,
    debug: debug,
    offsetX: offsetX,
    offsetY: offsetY,
    fit: fit
  });
  var src = optimized ? optimizedSrc : image.url;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Img, _extends({
    ref: setRef,
    src: src,
    alt: image.title || " ",
    width: (_image$dimension = image.dimension) === null || _image$dimension === void 0 ? void 0 : _image$dimension.width,
    height: (_image$dimension2 = image.dimension) === null || _image$dimension2 === void 0 ? void 0 : _image$dimension2.height
  }, imgProps)), debug && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translateX(-50%) translateY(-50%)",
      background: "rgba(0,0,0,.7)",
      color: "white",
      fontWeight: "bold",
      fontSize: "1em",
      height: "auto",
      padding: "1em"
    }
  }, JSON.stringify(image.dimension), /*#__PURE__*/_react.default.createElement("br", null), JSON.stringify(dimensions), /*#__PURE__*/_react.default.createElement("br", null), src.slice(src.lastIndexOf("?") + 1)));
});

exports.ContentstackImg = ContentstackImg;
ContentstackImg.displayName = "ContentstackImg";
var _default = ContentstackImg;
exports.default = _default;